import {computed} from 'mobx';

import APIRequestState from './_util/api-request';

class AddressState extends APIRequestState {
  @computed get search() {
    if (this.response) {
      return this.response.search;
    }
    return this.error && this.error.json && this.error.json.search;
  }

  async getRequest(place_id) {
    const [resultSource, result_id] = decodeURIComponent(place_id).split(':', 2);
    const response = await this.ctx.sdk
      .get(`/search/location/validate?resultSource=${resultSource}&result_id=${result_id}`);

    return response;
  }
}

export default AddressState;



// WEBPACK FOOTER //
// ./spa/state/address.jsx